import { STATIC_TEXT_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import { isInGroup } from '@frontend/utils';
import { fabric } from 'fabric';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { getGroupNameByAddFieldId } from "@/common/preview/draw-smart-object";
import { FIELD_TYPE_SMART_OBJECT } from "@frontend/constants/type-fields-of-template";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export function drawStaticText({
  fields,
  data,
  canvas,
  id,
  group_fields,
  dimension,
}) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.includes(STATIC_TEXT_PREFIX_ID)) {
      canvas.remove(o);
    }
  });
  
  const { canvas_data } = getScopePage();
  
  canvas_data[id].stTextCoords = [];
  let index = 0;
  
  fields.forEach((field) => {
    const options = JSON.parse(field.options);
    const groupName = getGroupNameByAddFieldId(
      String(field.id),
      canvas_data[id]
    );
    
    if (field.type === 'Static Text' && (!group_fields || isInGroup(group_fields, field.name))) {
      const text_val = options['Option1'] || options['Placeholder'] || options['Name'];
      const offset_x = data[`${field.element_id}_offset_x`];
      const offset_y = data[`${field.element_id}_offset_y`];
      const visible = !options['Hidden'];
      const isCurved = data[`${field.element_id}_is_curved`] || false;
      const curvedDiameter = Number(data[`${field.element_id}_diameter`]) || 1000;
      if (text_val !== '') {
        const text = new fabric.Textbox(text_val, {
          id: STATIC_TEXT_PREFIX_ID + index,
          groupName: groupName,
          element_id: field.element_id,
          order: parseInt(options['Order']),
          top: parseFloat(options['Y']) + parseFloat(offset_y),
          left: canvas_data[id].spacingFieldPosition[field.name] 
            ? canvas_data[id].spacingFieldPosition[field.name].x : parseFloat(options['X']) + parseFloat(offset_x),
          width: parseInt(options['Width']),
          textAlign: options['Alignment'] ? options['Alignment'] : 'left',
          fontSize: options['Font Size'] ? parseInt(options['Font Size']) : 50,
          lineHeight: options['Leading'] ? parseFloat(options['Leading']) : 1,
          fill: options['Font Color'] ? options['Font Color'] : '#000000',
          fontFamily: options['Font'] ? options['Font'] : 'Proxima-Nova-Semibold',
          selectable: options['Moveable'] === 'Yes',
          evented: options['Moveable'] === 'Yes',
          charSpacing: options['Text Tracking'] ? parseInt(options['Text Tracking']) : 0,
          fieldId: options['id'],
          visible,
          isCurved,
          curvedDiameter
        });

        let group_x = 0
        let group_y = 0;
        
        if (groupName && canvas_data[id].smartObjCoords[groupName]) {
          group_x = parseInt(canvas_data[id].smartObjCoords[groupName]['X']);
          group_y = parseInt(canvas_data[id].smartObjCoords[groupName]['Y']);
        }
        
        text.set({
          left: text.left + group_x - dimension[2] + dimension[4].x,
          top: text.top + group_y - dimension[3] + dimension[4].y
        });

        canvas.add(text);
        
        canvas_data[id].stTextCoords.push({
          x: parseFloat(options['X']),
          y: parseFloat(options['Y']),
        });
        
        index++;
      }
    }
  });
}
